import { Component, HostBinding, ChangeDetectionStrategy, inject } from '@angular/core';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2';
import { WindowService } from './shared/service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent {
  private analytics = inject(Angulartics2GoogleGlobalSiteTag);
  private windowService = inject(WindowService);

  constructor() {
    this.analytics.startTracking();
  }
}
